/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'company-hub.carousel-extension.card-strip.card.label': '第 {positionInSet} 張投影片 (共 {setSize} 張)',
  'company-hub.carousel-extension.carousel-content.extra-small-frame.placeholder-title': '新增標題',
  'company-hub.carousel-extension.carousel-navigation.pause': '暫停',
  'company-hub.carousel-extension.carousel-navigation.play': '播放',
  'company-hub.carousel-extension.carousel-navigation.row-orientation.next': '下一個',
  'company-hub.carousel-extension.carousel-navigation.row-orientation.previous': '上一個',
  'company-hub.carousel-extension.config-panel.add-frame-cta': '新增框架',
  'company-hub.carousel-extension.config-panel.field.frames.error.invalid-list': '新增框架',
  'company-hub.carousel-extension.config-panel.layout.title': '選擇版面配置',
  'company-hub.carousel-extension.config-panel.layouts.frame-above-image.label': '有框架的文字放在圖片上方',
  'company-hub.carousel-extension.config-panel.layouts.solid-color-background.label': '純色背景',
  'company-hub.carousel-extension.config-panel.layouts.split-design-content.label': '分割設計',
  'company-hub.carousel-extension.config-panel.link.field.label': '連結',
  'company-hub.carousel-extension.config-panel.lozenge.label.updated': '已更新',
  'company-hub.carousel-extension.config-panel.navigation.progress-circles': '進度圈',
  'company-hub.carousel-extension.config-panel.navigation.thumbnails': '縮圖',
  'company-hub.carousel-extension.config-panel.preamble-link.label-v2': '深入了解輪播',
  'company-hub.carousel-extension.config-panel.preamble-v2': '設計一組最多 {number} 個的旋轉框架。{supportLink}',
  'company-hub.carousel-extension.config-panel.preamble-v2-without-support-link':
    '設計一組最多 {number} 個的旋轉框架。',
  'company-hub.carousel-extension.config-panel.style.general.title': '一般',
  'company-hub.carousel-extension.config-panel.style.navigation.title': '導覽',
  'company-hub.carousel-extension.config-panel.styles.autoplay-label': '自動播放',
  'company-hub.carousel-extension.config-panel.styles.autoplay-tooltip-content':
    '將您的輪播設定為在檢視模式下每 {number} 秒自動滾動',
  'company-hub.carousel-extension.config-panel.tab.content.label': '內容',
  'company-hub.carousel-extension.config-panel.tab.styles.label': '樣式',
  'company-hub.carousel-extension.config-panel.title': '輪播',
  'company-hub.carousel-extension.description.field.label': '描述',
  'company-hub.carousel-extension.description.placeholder': '自訂此框架以建立旋轉輪播。',
  'company-hub.carousel-extension.frame-spotlight.label': '第 {positionInSet} 個框架，共 {setSize} 個',
  'company-hub.carousel-extension.frame.background.color': '背景顏色',
  'company-hub.carousel-extension.frame.color-contrast.fail': '您的文字和背景顏色搭配無法凸顯內容。',
  'company-hub.carousel-extension.frame.color-contrast.success': '您的文字和背景顏色搭配可以凸顯內容。',
  'company-hub.carousel-extension.frame.text.color': '文字顏色',
  'company-hub.carousel-extension.hub-element.description': '一組好看的輪播架構',
  'company-hub.carousel-extension.hub-element.title': '輪播',
  'company-hub.carousel-extension.manifest.macro-description': '建立動態框架的三重輪替。',
  'company-hub.carousel-extension.manifest.macro-title': '輪播',
  'company-hub.carousel-extension.manifest.macro-title.updated': '輪播 [已更新]',
  'company-hub.carousel-extension.placeholder.description': '自訂此框架以建立旋轉輪播。',
  'company-hub.carousel-extension.placeholder.title': '為框架提供標題',
  'company-hub.carousel-extension.recommended.field.label': '(推薦)',
  'company-hub.carousel-extension.title.field.label': '標題',
  'company-hub.carousel-extension.title.placeholder': '為框架提供標題',
};
